/* ==========================================================
	VENDOR LIST SEARCH (reactive typing)
	- Uses the existing input in Liquid: .vendor-filter-search__input
	- Shows/Hides vendors in real-time while typing
	- Disables letter anchors that have no matches (no layout shift)
	- Case-insensitive, trims spaces
========================================================== */
(() => {
	const SELECTORS = {
		root: '.section-vendor-list',
		searchInput: '.vendor-filter-search__input',
		filter: '.vendor-filter',
		columns: '.vendor-list--column',
		vendorItem: 'li',
		vendorLink: 'a',
	};

	const CLASSES = {
		disabled: 'is-disabled',
	};

	function norm(str){
		return (str || '').toString().trim().toLowerCase();
	}

	function debounce(fn, wait = 80){
		let t = null;
		return (...args) => {
			window.clearTimeout(t);
			t = window.setTimeout(() => fn(...args), wait);
		};
	}

	function prepare(root){
		const columns = Array.from(root.querySelectorAll(SELECTORS.columns));

		columns.forEach((col) => {
			const items = Array.from(col.querySelectorAll(SELECTORS.vendorItem));

			items.forEach((li) => {
				const a = li.querySelector(SELECTORS.vendorLink);
				if(!a) return;

				li.dataset.vendorName = norm(a.textContent);
			});
		});
	}

	function filterReactive(root, queryRaw){
		const query = norm(queryRaw);

		const columns = Array.from(root.querySelectorAll(SELECTORS.columns));
		const filterLis = Array.from(root.querySelectorAll(`${SELECTORS.filter} > li`));

		columns.forEach((col) => {
			const vendorLis = Array.from(col.querySelectorAll(SELECTORS.vendorItem));
			let colHasVisible = false;

			vendorLis.forEach((li) => {
				const vendorName = li.dataset.vendorName;
				if(!vendorName) return;

				// Reactive typing match
				// If you want EXACT match only, replace "includes" with "===".
				const show = query === '' ? true : vendorName.includes(query);

				li.style.display = show ? '' : 'none';
				if(show) colHasVisible = true;
			});

			// Keep the column layout stable? Here we still hide empty columns.
			// If you also want columns to stay and just dim them, tell me and I switch to a class.
			col.style.display = colHasVisible ? '' : 'none';
			col.dataset.hasVisible = colHasVisible ? '1' : '0';
		});

		// Disable letter anchors instead of hiding them (no layout shift)
		filterLis.forEach((li) => {
			const a = li.querySelector('a');
			if(!a) return;

			const href = a.getAttribute('href') || '';

			if(href === '#tutti'){
				li.classList.remove(CLASSES.disabled);
				return;
			}

			const targetId = href.replace('#', '');
			const col = targetId ? root.querySelector(`#${CSS.escape(targetId)}`) : null;

			const hasVisible = col ? col.dataset.hasVisible === '1' : false;

			li.classList.toggle(CLASSES.disabled, !hasVisible);
		});
	}

	function initRoot(root){
		const input = root.querySelector(SELECTORS.searchInput);
		if(!input) return;

		prepare(root);

		const run = () => {
			filterReactive(root, input.value);
		};

		run();

		input.addEventListener('input', debounce(run, 80));

		input.addEventListener('keydown', (e) => {
			if(e.key !== 'Escape') return;
			input.value = '';
			run();
		});
	}

	function init(){
		const roots = Array.from(document.querySelectorAll(SELECTORS.root));
		if(!roots.length) return;

		roots.forEach(initRoot);
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', init);
	}else{
		init();
	}
})();